module.exports = __webpack_public_path__ + "images/category_lp/electric_tool/assessment_achievements/4_b836099bca08c105727a72763219a810.jpg";